/** @file Activity panel registration (spec §9: live commit feed, actor badges, per-row revert, presence). */
import type { PanelEntry } from '../panelEntry';
import { ActivityPanel } from './ActivityPanel';

/** A DOM panel: no canvas, so the default renderer is fine. */
export const panel: PanelEntry = { id: 'activity', title: 'activity.title', bindings: [], component: ActivityPanel };
